import 'iframe-resizer/js/iframeResizer.contentWindow';
import './styles.fractal.scss';

import { default as AlertExample } from './components/alert/alert--example';
import { default as SelectExample } from './components/forms/select/select--disabled-example';

// eslint-disable-next-line
import * as components from '.';

module.exports = {
    ...components,
    AlertExample,
    SelectExample,
};
